import { useState } from 'react';

import Modal, { ModalHeader, ModalBody, ModalFooter } from '../../../../../../modal/Modal';
import Button from '../../../../../../primitives/form/button/Button';
import TextareaField from '../../../../../../primitives/form/TextareaField/TextareaField';
import WarningMessage from '../../../../../../WarningMessage/WarningMessage';

function ActiveToggleConfirmation(props) {
  const [changeReasonValue, setChangeReasonValue] = useState('');

  const { showModal, active, closeModal, handleConfirmation, showLoadingIcon } = props;

  return (
    <Modal showModal={showModal} modalSize="small">
      <ModalHeader>
        <h1 className="modal__small-title">Confirm Action</h1>
        <h2 className="modal__large-title">{active ? 'Deactivate form' : 'Activate form'}</h2>
      </ModalHeader>
      <ModalBody>
        <WarningMessage
          message={
            active
              ? 'Deactivating this Form Template will prevent any new Forms from being created. All data will remain accessible.'
              : 'Activating this Form Template will make it live for allocated Libraries and allow authorised Users to fill in Forms based on this Form Template.'
          }
          danger={active}
        />
        <div className="form__group-wrapper form__group-wrapper">
          <div className="form form__group">
            <TextareaField
              fieldID="reason_for_change"
              fieldIdentifier="reason-for-change"
              fieldName={active ? 'Reason for deactivation' : 'Reason for activation'}
              fieldRequired
              value={changeReasonValue}
              handleChange={(event) => setChangeReasonValue(event.target.value)}
              disabled={false}
              autoComplete="off"
            />
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <div className="form modal__footer--forms">
          <div className="cta__group cta__group--form">
            <Button
              name="CONFIRM"
              actionType="button"
              disable={showLoadingIcon || !changeReasonValue}
              buttonType="primary"
              loadingIcon={showLoadingIcon}
              handleClick={(e) => handleConfirmation(!active, changeReasonValue)}
              dataTestId="confirm-button"
            />
            <Button
              name="CANCEL"
              actionType="button"
              disable={false}
              buttonType="light"
              handleClick={() => closeModal()}
              dataTestId="cancel-button"
            />
          </div>
        </div>
      </ModalFooter>
    </Modal>
  );
}

export default ActiveToggleConfirmation;
